import { object, func } from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { intlShape } from '../../../util/reactIntl'
import css from './PricePackages.module.css'
import { subUnitDivisors } from '../../../config/settingsCurrency';
import { formatMoney } from '../../../util/currency';
const { types } = require('sharetribe-flex-sdk');
const { Money } = types;

function convertFormat(key) {
    switch (key) {
        case "perDayPrice":
            return "Per day";
        case "perHourPrice":
            return "Per hour";
        case "perMinutePrice":
            return "Per minute";
        case "overnightPrice":
            return "Overnight";
        case "oneWeekPrice":
            return "7 days";
        case "twoDaysPrice":
            return "2 days";
        case "twentyEightDaysPrice":
            return "28 days";
        default:
            return "";
    }
};

export default function PricePackages(props) {
    const { packages, intl, setSelectedPackage, selectedPackage, currentUserCurrency, customPackage } = props;

    const packageContainerRef = useRef(null);
    // Drag state
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    // Restore selectOptions logic
    const selectOptions = Object.keys(packages)
        .map(p =>
        ({
            key: p,
            label: convertFormat(p),
            price: formatMoney(intl, new Money(packages[p].amount, packages[p].currency))
        })
        );

    if(customPackage) {
        selectOptions.unshift({
            key: 'custom',
            label: customPackage.label,
            price: formatMoney(intl, customPackage.price)
        })
    };

    // Mouse event handlers for drag-to-scroll
    useEffect(() => {
        const container = packageContainerRef?.current;
        if (!container) return;

        const onMouseDown = (e) => {
            isDragging.current = true;
            startX.current = e.pageX - container.offsetLeft;
            scrollLeft.current = container.scrollLeft;
            container.classList.add(css.dragging);
        };
        const onMouseLeave = () => {
            isDragging.current = false;
            container.classList.remove(css.dragging);
        };
        const onMouseUp = () => {
            isDragging.current = false;
            container.classList.remove(css.dragging);
        };
        const onMouseMove = (e) => {
            if (!isDragging.current) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX.current) * 1; // scroll-fastness
            container.scrollLeft = scrollLeft.current - walk;
        };
        // Touch events for mobile
        const onTouchStart = (e) => {
            isDragging.current = true;
            startX.current = e.touches[0].pageX - container.offsetLeft;
            scrollLeft.current = container.scrollLeft;
            container.classList.add(css.dragging);
        };
        const onTouchEnd = () => {
            isDragging.current = false;
            container.classList.remove(css.dragging);
        };
        const onTouchMove = (e) => {
            if (!isDragging.current) return;
            const x = e.touches[0].pageX - container.offsetLeft;
            const walk = (x - startX.current) * 1;
            container.scrollLeft = scrollLeft.current - walk;
        };

        container.addEventListener('mousedown', onMouseDown);
        container.addEventListener('mouseleave', onMouseLeave);
        container.addEventListener('mouseup', onMouseUp);
        container.addEventListener('mousemove', onMouseMove);
        container.addEventListener('touchstart', onTouchStart);
        container.addEventListener('touchend', onTouchEnd);
        container.addEventListener('touchmove', onTouchMove);

        return () => {
            container.removeEventListener('mousedown', onMouseDown);
            container.removeEventListener('mouseleave', onMouseLeave);
            container.removeEventListener('mouseup', onMouseUp);
            container.removeEventListener('mousemove', onMouseMove);
            container.removeEventListener('touchstart', onTouchStart);
            container.removeEventListener('touchend', onTouchEnd);
            container.removeEventListener('touchmove', onTouchMove);
        };
    }, []);

    useEffect(() => {
        if (!packageContainerRef.current) return;
        let key = !!customPackage ? 'custom' : selectedPackage;
        const el = packageContainerRef.current.querySelector(`[data-package="${key}"]`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

      }, [selectedPackage, customPackage]);
      


    return (
        <div className={css.packagesContainer} ref={packageContainerRef}>
            {selectOptions.map((opt) => (
                <button
                    className={
                        opt.key === 'custom'
                            ? `${css.package} ${css.active}`
                            : selectedPackage === opt.key && !customPackage
                                ? `${css.package} ${css.active}`
                                : css.package
                    }
                    key={opt.key}
                    onClick={() => setSelectedPackage(opt.key)}
                    data-package={opt.key}
                >
                    <p className={css.packageLable}> {opt.price}</p>
                    <p className={css.packagePrice}> {opt.label} </p>
                </button>
            ))}
        </div>
    )
};

PricePackages.prototype = {
    packages: object.isRequired,
    intl: intlShape.isRequired,
    setSelectedPackage: func.isRequired
}
